import React, { useEffect } from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppSelector, useAppDispatch} from "../../utils/Hooks";
import { useNavigate } from "react-router-dom";
import {getToday} from "../../store/reducers/InfoSlice";

const UnpaidLock: React.FC = () => {
    const infoState = useAppSelector(state => state.info);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            dispatch(getToday());
        }, 10000);

        return () => {
            clearInterval(interval);
        };
    }, [dispatch]);

    useEffect(() => {
        if ((infoState.unpaid.length === 0) && (infoState.insurance.length === 0)) {
            const previousUrl = sessionStorage.getItem('referrerUrl');

            if (previousUrl) {
                console.log('NAVIGATING', previousUrl);
                sessionStorage.removeItem('referrerUrl');
                navigate(previousUrl);
            }
        }
    }, [infoState.unpaid, infoState.insurance]);

    return (
        <LoggedInView fullWidth={true}>
            {infoState?.unpaid?.length > 0 &&
            <>
              <h1>E-log on lukus kuni järgnevate vedude arved pole tasutud. Kaupa on keelatud maha laadida!</h1>
              <br/>
              <table className="data">
                <thead>
                <tr>
                  <th style={{width: '5%'}}>Kuupäev</th>
                  <th style={{width: '5%'}}>Mahalaadimise kuupäev</th>
                  <th style={{width: '10%'}}>Klient</th>
                  <th style={{width: '10%'}}>Hankija</th>
                  <th style={{width: '15%'}}>Müügiarve number</th>
                  <th style={{width: '15%'}}>Marsruut</th>
                  <th style={{width: '50%'}}>Kommentaar</th>
                  <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {infoState.unpaid.map(order => (
                    <tr key={order.id}>
                        <td>{order.order_time}</td>
                        <td>{order.loading_time}</td>
                        <td>{order.client?.name}</td>
                        <td>{order.vendor?.name}</td>
                        <td>{order.sale_invoice}</td>
                        <td>{`${order.loading_country} (${order.loading_cities}) - ${order.unloading_country} (${order.unloading_cities})`}</td>
                        <td>{order.comment}</td>
                        <td className="action"></td>
                    </tr>
                ))}
                </tbody>
              </table>
            </>
            }
            {infoState?.insurance?.length > 0 &&
            <>
              <h1>E-log on lukus kuni järgnevate vedude kindlustuse arved pole tasutud. Kaupa on keelatud maha
                laadida!</h1>
              <br/>
              <table className="data">
                <thead>
                <tr>
                  <th style={{width: '5%'}}>Kuupäev</th>
                  <th style={{width: '5%'}}>Mahalaadimise kuupäev</th>
                  <th style={{width: '10%'}}>Klient</th>
                  <th style={{width: '10%'}}>Hankija</th>
                  <th style={{width: '15%'}}>Müügiarve number</th>
                  <th style={{width: '15%'}}>Marsruut</th>
                  <th style={{width: '50%'}}>Kommentaar</th>
                  <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {infoState.insurance.map(order => (
                    <tr key={order.id}>
                        <td>{order.order_time}</td>
                        <td>{order.loading_time}</td>
                        <td>{order.client?.name}</td>
                        <td>{order.vendor?.name}</td>
                        <td>{order.sale_invoice}</td>
                        <td>{`${order.loading_country} (${order.loading_cities}) - ${order.unloading_country} (${order.unloading_cities})`}</td>
                        <td>{order.comment}</td>
                        <td className="action"></td>
                    </tr>
                ))}
                </tbody>
              </table>
            </>
            }

        </LoggedInView>
    );
};

export default UnpaidLock;